import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { isEmpty } from '@dxb-web-ui-framework/common/utils';
import { ExtendedComponentSchema } from '@dxb-web-ui-framework/content-composer/components/FormBuilder/types';
import { ClientSideWizardStepConfiguration } from '../contexts/ClientSideWizard/types';

const getStepsConfigurationWithDefaultValues = (
  stepsConfig: { [key: string]: ClientSideWizardStepConfiguration },
  preloadedData?: GenericObject<any>,
): { [key: string]: ClientSideWizardStepConfiguration } => {
  if (preloadedData && !isEmpty(preloadedData)) {
    const preloadedDataValues = Object.values(preloadedData.data) as { stepId: string; values: GenericObject }[];
    const stepsConfigValues = Object.values(stepsConfig);
    const stepConfigWithComponentsPreloadedValues = {} as { [key: string]: ClientSideWizardStepConfiguration };

    for (const stepConfig of stepsConfigValues) {
      for (const { stepId, values } of preloadedDataValues) {
        if (
          stepId === stepConfig.stepId &&
          stepConfig.parameters.components &&
          !isEmpty(stepConfig.parameters.components)
        ) {
          const configComponents = stepConfig.parameters.components.map((component: ExtendedComponentSchema) => {
            if (component.components && !isEmpty(component.components)) {
              component.components.map((childrenComponent: ExtendedComponentSchema) => {
                if (childrenComponent.key === values[childrenComponent.key]) {
                  return {
                    ...childrenComponent,
                    defaultValue: values[childrenComponent.key] ?? '',
                  };
                }
                return component;
              });
            }
            if (component.key === values[component.key]) {
              return {
                ...component,
                defaultValue: values[component.key] ?? '',
              };
            }
            return component;
          });
          stepConfigWithComponentsPreloadedValues[stepConfig.stepId as string] = {
            ...stepConfig,
            parameters: { ...stepConfig.parameters, components: configComponents },
          };
        }
      }
    }

    return stepConfigWithComponentsPreloadedValues;
  }

  return stepsConfig;
};

export { getStepsConfigurationWithDefaultValues };
